/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_No_Spaces_YetInputs */



/**
* | output |
* | --- |
* | "No dataset spaces yet" |
*
* @param {Datasets_No_Spaces_YetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_no_spaces_yet = /** @type {((inputs?: Datasets_No_Spaces_YetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_No_Spaces_YetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Datensatz-Bereiche")
	return /** @type {LocalizedString} */ ("No dataset spaces yet")
});